module.exports = __webpack_public_path__ + "img/analysis.1c718324.png";